<pos-manager-header
  *ngIf="!showMostPopularItems"
  [title]="'posManager.realTimeInfo' | transloco"></pos-manager-header>
<ion-content>
  <div class="h-full custom-flex-col">
    <!-- Most Popular Items Component -->
    <div *ngIf="showMostPopularItems" class="most-popular-items-container">
      <pos-most-popular-items
        [mostPopularItems]="mostPopularItems"
        [selectedMealId]="form.get('selectedMealId')?.value"
        [onMealChange]="onMostPopularItemsMealChange.bind(this)"
        [posLocationId]="form.get('selectedLocationId')?.value"
        [date]="selectedDateStr"
        (backClicked)="hideMostPopularItemsView()">
      </pos-most-popular-items>
    </div>

    <!-- Main Dashboard Content -->
    <div [class.hidden]="showMostPopularItems">
      <div class="location-wrapper">
        <form [formGroup]="form">
          <ion-grid class="ion-no-margin ion-no-padding">
            <ion-row class="text-sm font-bold">
              <ion-col
                size="4"
                class="custom-flex-col ion-justify-content-end ion-padding-horizontal">
                <pos-datepicker
                  [maxDay]="7"
                  [showDatePicker]="true"
                  (dateChanged)="onDateChanged($event)"
                  displayDateFormat="ddd, MMMM DD YYYY"
                  [currentLocale]="currentLocale$ | async">
                </pos-datepicker>
              </ion-col>
              <ion-col
                size="4"
                class="custom-flex-col ion-justify-content-end ion-padding-horizontal">
                <ion-item mode="md" class="border text-inherit grey-bg">
                  <div
                    class="grow custom-flex-row flex-gap-px-8 ion-align-items-center">
                    <span class="font-bold"
                      >{{ 'posManager.location' | transloco }}</span
                    >
                    <ion-select
                      translocoSelect
                      class="font-normal ion-no-padding grow"
                      formControlName="selectedLocationId">
                      <ion-select-option
                        *ngFor="let item of locations"
                        [value]="item.id"
                        >{{ item.name }}
                      </ion-select-option>
                    </ion-select>
                  </div>
                </ion-item>
              </ion-col>
              <ion-col
                size="4"
                class="custom-flex-row flex-gap-px-8 ion-align-items-end ion-padding-horizontal">
                <div class="grow custom-flex-col ion-justify-content-end">
                  <ion-segment
                    style="width: auto"
                    mode="md"
                    formControlName="selectedMealId">
                    <div class="custom-flex-row">
                      <ion-segment-button [value]="MealTime.Breakfast">
                        <ion-label
                          >{{ 'meals.breakfast' | transloco }}</ion-label
                        >
                      </ion-segment-button>
                      <ion-segment-button [value]="MealTime.Lunch">
                        <ion-label>{{ 'meals.lunch' | transloco }}</ion-label>
                      </ion-segment-button>
                      <ion-segment-button [value]="MealTime.Dinner">
                        <ion-label>{{ 'meals.dinner' | transloco }}</ion-label>
                      </ion-segment-button>
                    </div>
                  </ion-segment>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </form>
      </div>
      <div class="dashboard">
        <div class="totals">
          <div class="totals__container">
            <div class="totals__container__datagrid">
              <div class="totals__container__datagrid__title">
                {{ 'posManager.totalOrders' | transloco }}
              </div>
              <div class="totals__container__datagrid__value">
                {{ realtimeTotals.total_orders }}
              </div>
            </div>
            <div class="totals__container__datagrid">
              <div class="totals__container__datagrid__title">
                {{ 'posManager.totalSales' | transloco }}
              </div>
              <div class="totals__container__datagrid__value">
                {{ (realtimeTotals.total_sales || 0) | currency }}
              </div>
            </div>
          </div>

          <div class="popular-items mobile-order">
            <div class="popular-items__title">
              {{ 'posManager.mostPopularItems' | transloco }}
            </div>
            <div class="popular-items__container">
              <div *ngIf="mostPopularItems.length > 0; else noPopularItems;">
                <div
                  *ngFor="let item of mostPopularItems | slice:0:10; let i = index"
                  class="popular-items__container__item">
                  <div>{{ i + 1 }}. {{ item.name }}</div>
                  <div>{{ item.order_count }}</div>
                </div>
                <ion-button
                  *ngIf="mostPopularItems.length >= 10"
                  class="view-all-button"
                  expand="block"
                  (click)="showMostPopularItemsView()"
                  >{{ 'posManager.viewAll' | transloco }}</ion-button
                >
              </div>
            </div>
          </div>

          <div class="types">
            <div class="types__title">
              {{ 'posManager.byPaymentType' | transloco }}
            </div>
            <ion-grid class="type-grid">
              <ion-row
                *ngFor="let paymentType of (realtimeSalesByPaymentType | realtimeTypeDisplay:paymentTypeMap)">
                <ion-col size="6"
                  >{{ paymentType.displayName | transloco }}</ion-col
                >
                <ion-col size="4" class="ion-text-end"
                  >{{ (paymentType.amount || 0) | currency }}</ion-col
                >
                <ion-col size="2" class="ion-text-end"
                  >{{ paymentType.count }}</ion-col
                >
              </ion-row>
              <!-- Show message if no data available -->
              <ion-row
                *ngIf="(realtimeSalesByPaymentType | realtimeTypeDisplay:paymentTypeMap).length === 0">
                <ion-col size="12" class="text-center text-gray-500">
                  {{ 'posManager.noPaymentDataAvailable' | transloco }}
                </ion-col>
              </ion-row>
            </ion-grid>
            <div class="types__title">
              {{ 'posManager.byDinerType' | transloco }}
            </div>
            <ion-grid class="type-grid">
              <ion-row
                *ngFor="let dinerType of (realtimeSalesByDinerType | realtimeTypeDisplay:dinerTypeMap)">
                <ion-col size="6"
                  >{{ dinerType.displayName | transloco }}</ion-col
                >
                <ion-col size="4" class="ion-text-end"
                  >{{ (dinerType.amount || 0) | currency }}</ion-col
                >
                <ion-col size="2" class="ion-text-end"
                  >{{ dinerType.count }}</ion-col
                >
              </ion-row>
            </ion-grid>

            <div
              style="
                padding-top: 16px;
                display: flex;
                flex-direction: column;
                gap: 5px;
              ">
              <ion-button
                class="total-sale-button"
                fill="clear"
                (click)="onTotalSaleButtonClicked()">
                <span class="total-sale-button__title"
                  >{{ 'posManager.totalSaleByMenuCategory' | transloco }}</span
                >
                <fa-icon [icon]="faChevronRight" class="chevron-icon"></fa-icon>
              </ion-button>
              <ion-button
                class="total-sale-button"
                fill="clear"
                (click)="onPosOperatorsButtonClicked()">
                <span class="total-sale-button__title"
                  >{{ 'posManager.posOperators' | transloco }}</span
                >
                <fa-icon [icon]="faChevronRight" class="chevron-icon"></fa-icon>
              </ion-button>
            </div>
          </div>
        </div>

        <div class="popular-items desktop-order">
          <div class="popular-items__title">
            {{ 'posManager.mostPopularItems' | transloco }}
          </div>
          <div class="popular-items__container">
            <div *ngIf="mostPopularItems.length > 0; else noPopularItems;">
              <div
                *ngFor="let item of mostPopularItems | slice:0:20; let i = index"
                class="popular-items__container__item">
                <div>{{ i + 1 }}. {{ item.name }}</div>
                <div>{{ item.order_count }}</div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noPopularItems>
          <div class="no-items">
            {{ 'posManager.noItemsToDisplay' | transloco }}
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</ion-content>
